<template>
	<div style="background-color: #efefef; padding: 20px; ">
		<div style="display: flex; flex-direction: row; justify-content: space-between; border-radius: 10px;">
			<div class="pannel" v-if="pay">
				<div class="title">通道信息</div>
				<div class="form-line">
					<div class="form-name">通道名称</div>
					<el-input class='form-inp' v-model="pay.pay_name" disabled size="small"></el-input>
				</div>
				<div class="form-line">
					<div class="form-name">通道编码</div>
					<el-input class='form-inp' v-model="pay.pay_code" disabled size="small"></el-input>
				</div>
				<div class="form-line">
					<div class="form-name">店铺开关</div>
					<el-switch v-model="pay.shop_status" :active-value="1" :inactive-value="0">
					</el-switch>
				</div>
				<div class="form-line">
					<div class="form-name">审核开关</div>
					<el-switch v-model="pay.pass_status" :active-value="1" :inactive-value="0">
					</el-switch>
				</div>
				<div class="form-line">
					<div class="form-name">平台开关</div>
					<el-switch v-model="pay.plat_status" :active-value="1" :inactive-value="0">
					</el-switch>
				</div>
				<div class="form-line">
					<div class="form-name">最低限额</div>
					<el-input class='form-inp' v-model="pay.low_limit" size="small"></el-input>
					</el-switch>
				</div>
				<div class="form-line">
					<div class="form-name">最高限额</div>
					<el-input class='form-inp' v-model="pay.high_limit" size="small"></el-input>
					</el-switch>
				</div>
				<div class="form-line">
					<div class="form-name">快捷金额</div>
					<el-input class='form-inp' v-model="pay.amount_list" size="small"></el-input>
					</el-switch>
				</div>
			</div>
			<div class="pannel" v-if="pay">
				<div class="title">通道配置</div>
				<div class="form-line">
					<el-input type="textarea" v-model="pay.params" style="width: 320px;" rows="16"></el-input>
					</el-switch>
				</div>
			</div>
		</div>
		<div>
			<div style="text-align: center; margin: 10px;">
				先编辑<span class='r'>配置通道信息</span>后，<span class='g'>"审核开关"</span>和<span class='g'>"平台开关"</span><span class='r'>同时开启</span>后，店主端<span class='r'>才可开启</span><span class='g'>"店铺开关"</span>
			</div>
			<div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
				<el-button type="primary" style="width: 200px; margin-right: 20px;" @click="save()">确认保存</el-button>
				<el-button type="danger" style="width: 200px;" @click="resetParams()">重置通道</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['id'],
		data() {
			return {
				pay: null
			}
		},
		watch: {},
		created() {
			this.getData();
		},
		methods: {
			save(){
				let _this = this;
				const loading = this.$loading({
					lock: true,
					text: '保存中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let sendPay = JSON.stringify(this.pay);
				sendPay = JSON.parse(sendPay);
				sendPay.params = JSON.parse(sendPay.params);
				sendPay.params = JSON.stringify(sendPay.params);
				_this.$api.post("/Shop/saveShopPayment", {
					payConfig: JSON.stringify(sendPay)
				}).then(res => {
					loading.close();
					if (res.code == 200) {
						return _this.$message({
							message: res.msg,
							type: 'success',
						});
					} else {
						return _this.$message({
							message: res.msg,
							type: 'warning',
						});
					}
				}).catch(err => {
					loading.close();
				});
			},
			resetParams(){
				let _this = this;
				const loading = this.$loading({
					lock: true,
					text: '重置中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				_this.$api.post("/Shop/resetShopPayment", {
					id: _this.id
				}).then(res => {
					loading.close();
					if (res.code == 200) {
						_this.$message({
							message: '重置成功',
							type: 'success',
						});
						_this.getData();
					} else {
						return _this.$message({
							message: res.msg,
							type: 'warning',
						});
					}
				}).catch(err => {
					loading.close();
				});
			},
			getData() {
				let _this = this;
				const loading = this.$loading({
					lock: true,
					text: '获取数据',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				_this.$api.post("/Shop/getPayment", {
					id: _this.id
				}).then(res => {
					loading.close();
					if (res.code == 200) {
						_this.pay = res.data;
						const obj = JSON.parse(res.data.params)
						this.pay.params = JSON.stringify(obj, null, 2)
						  
					} else {
						return _this.$message({
							message: res.msg,
							type: 'warning',
						});
					}
				}).catch(err => {
					loading.close();
				});
			}
		}
	}
</script>

<style scoped>
	.g {
		color: #3399ff;
	}
	.r {
		color: red;
	}
	.pannel {
		padding: 20px;
		width: 360px;
		background-color: #fff;
		border-radius: 10px;
	}

	.title {
		color: #3399ff;
		font-weight: bold;
		font-size: 18px;
		text-align: center;
		padding-bottom: 10px;
		border-bottom: dashed 1px #3399ff;
		margin-bottom: 20px;
	}

	.form-line {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		margin: 20px 0;
	}

	.form-name {
		text-align: right;
		width: 60px;
		padding-right: 10px;
	}

	.form-inp {
		width: 200px;
		margin-right: 10px;
	}
</style>